export default "__VITE_ASSET__fdde7621__"